import { useTranslation } from 'react-i18next'

import LangLink from '../components/LangLink'
import Section from '../components/Section'

function PartnersPage() {
  const { t } = useTranslation()

  return (
    <div className="partners-page">
      <Section background="surface" space="md" className="partners-hero">
        <h1 className="display">{t('partners.title')}</h1>
        <p className="partners-lead">{t('partners.intro')}</p>
      </Section>

      <Section background="beige" space="lg" className="partners-list">
        {/* One primary partner today; more full-width cards drop in above the
            "open" card as the business grows. */}
        <article className="partner-card partner-card--feature">
          <picture>
            <source srcSet="/partner/building.webp" type="image/webp" />
            <img
              src="/partner/building.jpg"
              alt={t('partners.buildingAlt')}
              className="partner-card-img"
              loading="lazy"
              width={1100}
              height={1402}
            />
          </picture>
          <div className="partner-card-body">
            <p className="eyebrow">{t('partners.chinaRole')}</p>
            <h2>{t('partners.chinaName')}</h2>
            <p>{t('partners.chinaBlurb')}</p>
            <LangLink to="/partners/china" className="btn btn--secondary">
              {t('partners.chinaLink')}
            </LangLink>
          </div>
        </article>

        <article className="partner-card partner-card--open">
          <p className="eyebrow">{t('partners.openRole')}</p>
          <h2>{t('partners.openName')}</h2>
          <p>{t('partners.openBlurb')}</p>
          <LangLink to="/contact" className="btn btn--secondary">
            {t('partners.openLink')}
          </LangLink>
        </article>
      </Section>
    </div>
  )
}

export default PartnersPage
